<template>
    <div class="ui-loading">
      <!-- <img class="bg" :src="`${$cdn}images/bg.jpg`" alt=""> -->

      <div class="ui-con">
        <div>
          <img class="logo" :src="`${$cdn}/images/k.png`" alt="">
          
        </div>
        <div>
          <!-- <img class="loading" :src="`${$cdn}images/loading.png`" alt=""> -->
          <div class="loading" :style='{backgroundImage: `url("images/loading.png")`}'></div>
        </div>
        <div class="ld-txt">loading...</div>
      </div>
    </div>
</template>
<script>
export default {
    name: "ui-loading",
    data() {
        return {
           
        };
    },
    
};
</script>

<style lang="less" scoped>
@close-time:1s;
.ui-loading{
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  .bg{
    width: calc(100% - 200px);
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    position: fixed;
    user-select: none;
  }
  .ui-con{
    position: absolute;
    top: 48%;
    left: calc(50% - 200px / 2);
    transform: translate(-50%,-50%);
    text-align: center;
    >div:not(:last-of-type){
      text-align: center;
      margin-top: 40px;
    }
    .logo{
      width: 340px;
    }
    .loading{
      width: 149px;
      height:137px;
      background-repeat: no-repeat;
      margin: 0 auto;
      background-position: 0 0;
      background-size: cover;
      padding: 0;
      overflow-x: hidden;
      will-change: background;
      transform-style: preserve-3d;
      backface-visibility: hidden;
      animation: clock_ratate @close-time steps(75) infinite;
      
    }
    .ld-txt{
      font-family: 'SY-bold';
      font-size: 18px;
      margin-top: 16px;
    }
  }
}
@keyframes clock_ratate {
  0% {
    background-position: 0 0px;

  }
  100% {
    background-position: -11170px 0px;
  }
}
</style>